module.exports = __webpack_public_path__ + "static/21-07-15_17-50-12_6652-1500x1125-9b1f1d7c00dc09d3eb7703214ae18710.jpg";